import { FormApi } from 'final-form';

// item 1314 (Chad: "the forms that should auto fill — I have to click each time; it's back") —
// mount-time auto-fills (project customer → ship-to, picked drop-ship customer, the async doc
// prefill) must NEVER land inside react-final-form's render→subscribe window: a Field takes a
// render snapshot, subscribes in its effect, and treats the first notification as a duplicate
// of the snapshot. A form.change() fired by a SIBLING effect that runs first (tree order) is
// that swallowed first notification — the value is in form state (it saves!) but the input
// paints blank until the next event (a click). Item 936 patched the library for this; this
// helper removes the dependency on that patch surviving every build: the burst is deferred one
// macrotask, after every subscription exists, and batched so the fields repaint once.
export const deferFormChanges = (form: FormApi<any>, apply: () => void): (() => void) => {
  const t = window.setTimeout(() => form.batch(apply), 0);
  return () => window.clearTimeout(t);
};

export default deferFormChanges;
